<template>
    <transition name="cz3__fade">
        <div
            v-if="specialMessage"
            class="py-0.5 flex justify-center bg-gray-lighter font-sans"
        >
            <p class="mr-3 sm:mr-4 uppercase font-semibold text-sm">
                {{ specialMessage.title }}
            </p>

            <button
                type="button"
                @click="openPromoModal"
                class="h-auto text-xs underline"
            >
                {{ $t('DETAILS') }}
            </button>

            <promo-message-modal
                @modalClose="showModal = false"
                :show-modal="showModal"
            />
        </div>
    </transition>
</template>

<script>
    import allStores from '../stores/all';

    import PromoMessageModal from './PromoMessageModal.vue';

    export default {
        mixins: [allStores],

        components: {
            PromoMessageModal,
        },

        data() {
            return {
                showModal: false,
            };
        },

        computed: {
            specialMessage() {
                return this.customizerStore.specialMessage;
            },
        },

        methods: {
            openPromoModal() {
                this.showModal = true;
            },
        },
    };
</script>
